var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-multiselect',{attrs:{"fixed":_vm.fixed,"items":_vm.tags,"model":_vm.val,"placeholder":_vm.$t('labels.select_tag')},on:{"input":function($event){_vm.val = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }